import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const secretServer = defineConnector({
  identifier: "secretServer",
  name: "Secret Server",
  tagLine: "Privileged access management and secret vault",
  logo,
  protocol: "http",
  tags: ["security", "identity"],
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Create a Secret Server OAuth access token",
      items: [
        {
          kind: "markdown",
          content:
            "In Secret Server, authenticate against the `oauth2/token` endpoint to get an OAuth 2.0 access token, then use that token as a bearer token for API requests.",
        },
      ],
    },
    {
      title: "Enter your Secret Server details",
      items: [
        {
          kind: "url",
          label: "Secret Server base URL",
          required: true,
          placeholder: "https://your-secret-server.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
        },
        {
          kind: "input",
          label: "OAuth access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) =>
      `${instanceUrl || "https://your-secret-server.example.com"}/api/v1/folders`,
  },
  defaultUrlPattern: ({ instanceUrl }) => urlToPattern(instanceUrl, ""),
});
